import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

interface LocalStorageUpdate<T = any> {
  key: string;
  value: T;
}

@Injectable()
export class LocalStorageService {
  private itemChangeSubject: Subject<LocalStorageUpdate> = new Subject<LocalStorageUpdate>();

  observe<T>(key: string): Observable<T> {
    return this.itemChangeSubject.pipe(
      filter(update => update.key === key),
      map(update => update.value)
    );
  }

  set<T>(key: string, data: T): void {
    try {
      localStorage.setItem(key, JSON.stringify(data));
      this.itemChangeSubject.next({ key, value: data } as LocalStorageUpdate<T>);
    } catch (e) {
      console.error('Error saving to localStorage', e);
    }
  }

  get<T>(key: string, defaultValue: T = null): T | null {
    try {
      const value = JSON.parse(localStorage.getItem(key));
      return value ? value : defaultValue;
    } catch (e) {
      console.error('Error getting data from localStorage', e);
      return defaultValue;
    }
  }

  remove(key: string): void {
    localStorage.removeItem(key);
  }
}
